import { Component, Input, OnInit } from '@angular/core';
import { Ng1ModalService } from '../../../shared/ng1/ng1-modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-integration-list-item',
  templateUrl: './integration-list-item.component.html',
  styleUrls: ['./integration-list-item.component.scss']
})
export class IntegrationListItemComponent implements OnInit {
  @Input() path: string;
  @Input() logoPath: string;
  @Input() description: string;
  @Input() connectedIcon: string;
  @Input() isComingSoon: boolean;
  @Input() isFree: boolean;
  @Input() isActive: boolean;
  @Input() integrationType: string;
  constructor(private ng1ModalService: Ng1ModalService, private router: Router) {}

  ngOnInit() {
    // console.log(this.isFree);
    console.log(this.isActive);
  }

  navigateToLink() {
    const type = this.integrationType === 'TWO_WAY' || this.integrationType === 'ZAPIER';
    if (this.isFree && !type) {
      this.showUpgradeAccountModal();
      return;
    } else if (!this.isComingSoon) {
      this.router.navigateByUrl('/' + this.path);
    } else {
      return null;
    }
  }

  showUpgradeAccountModal() {
    return this.ng1ModalService.lazyModalService
      .showModal(
        {
          title: 'INTEGRATION_LIMIT_MODAL.TITLE',
          body: 'INTEGRATION_LIMIT_MODAL.TEXT',
          confirm: 'INTEGRATION_LIMIT_MODAL.CONFIRM'
        },
        true
      )
      .then(() => {
        this.router.navigateByUrl('/choose-plan');
      });
  }
}
